import {AbstractNegotiationCloser} from "@/modules/diplomacy/services/AbstractNegotiationCloser";
import {injectable} from "inversify";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";
import {Negotiation} from "@/modules/diplomacy/entity";
import {TransferOffer, TransferPlayerNegotiation, TransferTeamNegotiation} from "@/modules/transfer-market/entity";
import {TransferOfferStatusEnum} from "@/modules/transfer-market/enums";

@injectable()
export class TransferNegotiationCloser extends AbstractNegotiationCloser implements NegotiationCloserInterface {
  constructor() {
    super();
  }

  async shouldRun(negotiation: Negotiation) {
    return negotiation instanceof TransferPlayerNegotiation || negotiation instanceof TransferTeamNegotiation;
  }

  async close(negotiation: TransferPlayerNegotiation | TransferTeamNegotiation): Promise<void> {
    // const offer = await TransferOffer
    //   .createQueryBuilder('offer')
    //   .innerJoinAndSelect('offer.listing', 'listing')
    //   .innerJoinAndSelect('listing.player', 'player')
    //   .innerJoinAndSelect('offer.team', 'team')
    //   .innerJoinAndSelect('offer.playersTeam', 'playersTeam')
    //   .innerJoinAndSelect('offer.playerNegotiation', 'playerNegotiation')
    //   .innerJoinAndSelect('offer.teamNegotiation', 'teamNegotiation')
    //   .where('offer.id = :offerId', {offerId: negotiation.offer.id})
    //   .getOneOrFail();

    await this.endAllOtherNegotiations(negotiation);
    await super.close(negotiation);
  }

  async abort(negotiation: TransferPlayerNegotiation | TransferTeamNegotiation): Promise<void> {
    const offer = await TransferOffer
      .createQueryBuilder('offer')
      .leftJoinAndSelect('offer.listing', 'listing')
      .innerJoinAndSelect('offer.player', 'player')
      .innerJoinAndSelect('offer.team', 'team')
      .leftJoinAndSelect('offer.playersTeam', 'playersTeam')
      .innerJoinAndSelect('offer.playerNegotiation', 'playerNegotiation')
      .leftJoinAndSelect('offer.teamNegotiation', 'teamNegotiation')
      .where('offer.id = :offerId', {offerId: negotiation.offerId})
      .getOneOrFail();

    await [offer.playerNegotiation, offer.teamNegotiation]
      .forEachAsync(async (neg: Negotiation) => {
        await this.endAllOtherNegotiations(neg);
        await super.abort(neg);
      });

    offer.status = TransferOfferStatusEnum.FAILED;
    await offer.save();
  }
}